import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import App from './App.tsx'
import { ConsentProvider } from './context/ConsentContext'
import { startClientSentry } from './lib/sentryClient'

// Sentry client — error + performance monitoring only, no Session Replay.
// Started unconditionally at app boot: for a signed-in B2B tool this is
// operational telemetry that keeps the service reliable, disclosed in the
// cookie/privacy notice shown on first login (see `lib/consent.ts`).
startClientSentry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ConsentProvider>
        <App />
      </ConsentProvider>
    </BrowserRouter>
  </StrictMode>,
)
